import React, { Component } from "react";
import PropTypes from 'prop-types';

import "./DatepickerInput.scss";

class DatepickerInput extends Component {
  static propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func,
    onClick: PropTypes.func,
    placeholder: PropTypes.string,
  };

  static defaultProps = {
    value: '',
    placeholder: '',
    onChange: () => {},
    onClick: () => {},
  };

  render() {
    const { value, onChange, onClick, placeholder } = this.props;

    return (
      <div className="datepicker-input-wrap">
        <input
          className="datepicker-input"
          type="text"
          value={value}
          onChange={onChange}
          onClick={onClick}
          placeholder={placeholder}
        />
        <div className="datepicker-icon" />
      </div>
    );
  }
}

export default DatepickerInput;
